import { ChatMessage } from 'src/modules/event/eventAiChatService';
import actions from 'src/modules/event/aiChat/eventAiChatActions';

const initialData: { messages: ChatMessage[] } = {
  messages: [],
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.SET_MESSAGES) {
    return {
      ...state,
      messages: payload,
    };
  }

  if (type === actions.CLEAR) {
    return {
      ...state,
      messages: [],
    };
  }

  return state;
};
